import UserHeight from '../views/MobileScan/UserHeight.vue';
import Tutorial from '../views/MobileScan/Tutorial.vue';
import Scan from '../views/MobileScan/Scan.vue';
import Preview from '../views/MobileScan/Preview.vue';
import Uploading from '../views/MobileScan/Uploading.vue';
import UserProfile from '../views/MobileScan2/UserProfile.vue';
import Tutorial2 from '../views/MobileScan2/Tutorial.vue';
import CheckList from '../views/MobileScan2/CheckList.vue';
import Scan2 from '../views/MobileScan2/Scan.vue';

const mobileScanRoutes = [
  {
    path: '/mobile_scan/user_height',
    name: 'MobileScan/UserHeight',
    component: UserHeight,
  },
  {
    path: '/mobile_scan/tutorial',
    name: 'MobileScan/Tutorial',
    component: Tutorial,
  },
  {
    path: '/mobile_scan/scan',
    name: 'MobileScan/Scan',
    component: Scan,
  },
  {
    path: '/mobile_scan/preview',
    name: 'MobileScan/Preview',
    component: Preview,
    props: true,
  },
  {
    path: '/mobile_scan/uploading',
    name: 'MobileScan/Uploading',
    component: Uploading,
  },
  {
    path: '/mobile_scan2/user_profile',
    name: 'MobileScan2/UserProfile',
    component: UserProfile,
  },
  {
    path: '/mobile_scan2/tutorial',
    name: 'MobileScan2/Tutorial',
    component: Tutorial2,
  },
  {
    path: '/mobile_scan2/checkList',
    name: 'MobileScan2/CheckList',
    component: CheckList,
  },
  {
    path: '/mobile_scan2/scan',
    name: 'MobileScan2/Scan',
    component: Scan2,
  },
];

export default mobileScanRoutes;
